import { Product } from 'src/app/@utils/gtm-tracking/model/Product';
import { mapToTrackableProduct } from 'src/app/@utils/gtm-tracking/utils/mapToTrackableProduct';

import { ProductDetailViewModel } from '@models/api-search.models';

export type ProductDetailImpressionEvent = {
    event: 'view_item';
    ecommerce: {
        items: Product[];
    };
};

export const trackProductDetailImpressionEvent = (product: ProductDetailViewModel): ProductDetailImpressionEvent => ({
    event: 'view_item',
    ecommerce: {
        items: [mapToTrackableProduct(product)]
    }
});
